import React from 'react';
import { ChevronLeft, ChevronRight, Lightbulb } from 'lucide-react';
import { Button } from '../ui/button';

export const McqView = ({ item, index, skillName, value, onChange, onPrev, onNext }) => (
  <div className="absolute inset-0 z-20 bg-slate-50 overflow-y-auto" data-testid="mcq-view">
    <div className="max-w-3xl mx-auto px-6 py-10 space-y-6">
      <div className="flex items-center gap-2 text-xs">
        <span className="font-semibold text-amber-700 bg-amber-50 border border-amber-200 px-2.5 py-1 rounded-full flex items-center gap-1">
          <Lightbulb className="h-3.5 w-3.5" /> Scenario question {index}
        </span>
        <span className="text-slate-500">{skillName}</span>
      </div>
      <h2 className="text-xl sm:text-2xl font-bold text-slate-900 leading-snug" style={{ fontFamily: 'Manrope, sans-serif' }} data-testid="mcq-question">
        {item.prompt}
      </h2>
      <div className="space-y-3">
        {item.options.map((opt, i) => {
          const on = value === i;
          return (
            <button key={opt} type="button" onClick={() => onChange(on ? null : i)} data-testid={`mcq-option-${i}`}
              className={`w-full flex items-start gap-3 p-4 rounded-xl border text-left transition-[border-color,background-color,transform] duration-150
                ${on ? 'border-indigo-500 bg-indigo-50 shadow-[0_0_0_3px_rgba(79,70,229,0.12)]' : 'border-slate-200 bg-white hover:border-indigo-300 hover:translate-x-0.5'}`}>
              <span className={`w-7 h-7 rounded-md text-xs font-bold flex items-center justify-center shrink-0 ${on ? 'bg-indigo-600 text-white' : 'bg-slate-100 text-slate-600'}`}>
                {String.fromCharCode(65 + i)}
              </span>
              <span className="text-sm text-slate-800 font-mono leading-relaxed pt-1 break-words">{opt}</span>
            </button>
          );
        })}
      </div>
      <div className="flex justify-between pt-2">
        <Button variant="outline" onClick={onPrev} className="gap-1 bg-white" data-testid="mcq-prev-btn"><ChevronLeft className="h-4 w-4" /> Previous</Button>
        <Button onClick={onNext} className="gap-1 bg-slate-900 hover:bg-slate-800 text-white" data-testid="mcq-next-btn">Next <ChevronRight className="h-4 w-4" /></Button>
      </div>
    </div>
  </div>
);

export default McqView;
